import validator from 'validator';
import parsePhoneNumber from 'libphonenumber-js';
export const isName = (str) => {
    return str.length >= 2 && str.length <= 100;
};
export const isEmail = (str) => {
    return validator.isEmail(str);
};
export const isUrl = (str) => {
    return validator.isURL(str, {
        protocols: ['http', 'https'],
        require_protocol: true,
    });
};
export const isPhoneNumber = (str) => {
    var _a;
    const phoneNumber = parsePhoneNumber(str);
    /**
     * See: https://github.com/catamphetamine/libphonenumber-js#using-phone-number-validation-feature
     */
    return (_a = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.isPossible()) !== null && _a !== void 0 ? _a : false;
};
//# sourceMappingURL=validation.js.map